"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactIntl = require("react-intl");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _emotion = require("emotion");

var _colors = require("@cimpress/react-components/lib/colors");

var _IconAddCircle = _interopRequireDefault(require("@cimpress-technology/react-streamline-icons/lib/IconAddCircle"));

var _IconAdd = _interopRequireDefault(require("@cimpress-technology/react-streamline-icons/lib/IconAdd"));

var _TextField = _interopRequireDefault(require("@cimpress/react-components/lib/TextField"));

var _reactAutosuggest = _interopRequireDefault(require("react-autosuggest"));

var _flow = _interopRequireDefault(require("lodash/fp/flow"));

var _map = _interopRequireDefault(require("lodash/fp/map"));

var _trim = _interopRequireDefault(require("lodash/fp/trim"));

var _reject = _interopRequireDefault(require("lodash/fp/reject"));

var _isEmpty = _interopRequireDefault(require("lodash/fp/isEmpty"));

var _uniqWith = _interopRequireDefault(require("lodash/fp/uniqWith"));

var _isEqual = _interopRequireDefault(require("lodash/fp/isEqual"));

var _advancedTextField = _interopRequireDefault(require("./advancedTextField"));

var _styledComponents = require("./styledComponents");

var _messages = _interopRequireDefault(require("./messages"));

var _propTypes2 = require("./propTypes");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  margin-right: 10px;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  flex-grow: 8;\n  margin-right: 16px;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  justify-content: center;\n  display: flex;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var RETURN = 13;
var addFormLayout = (0, _emotion.css)(_templateObject());
var attributeSelect = (0, _emotion.css)(_templateObject2());
var smartButtonLayout = (0, _emotion.css)(_templateObject3());

var renderSuggestion = function renderSuggestion(suggestion) {
  return (
    /*#__PURE__*/
    _react["default"].createElement("span", null, suggestion.label)
  );
};

function splitValues(value, delimiters) {
  var splitRegex = new RegExp("[".concat(delimiters.join(''), "]"), 'i');
  var values = (value || '').split(splitRegex);
  return (0, _flow["default"])((0, _map["default"])(_trim["default"]), (0, _reject["default"])(_isEmpty["default"]))(values);
}

var AddForm =
/*#__PURE__*/
function (_Component) {
  _inherits(AddForm, _Component);

  var _super = _createSuper(AddForm);

  function AddForm(props) {
    var _this;

    _classCallCheck(this, AddForm);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "onChange", function (_ref) {
      var target = _ref.target;
      var value = target.value;
      var values = splitValues(target.value, _this.state.listDelimiter);

      _this.setState({
        value: value
      });

      _this.setState({
        values: splitValues(target.value, _this.state.listDelimiter)
      });

      _this.validateOption(value, values);
    });

    _defineProperty(_assertThisInitialized(_this), "onSuggestionSelected", function (event, _ref2) {
      var suggestionValue = _ref2.suggestionValue;

      _this.onAdd(suggestionValue);
    });

    _defineProperty(_assertThisInitialized(_this), "onSuggestionsFetchRequested", function (_ref3) {
      var value = _ref3.value;

      _this.setState({
        suggestions: _this.getSuggestions(value)
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onSuggestionsClearRequested", function () {
      _this.setState({
        suggestions: _this.props.selectOptions
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onAdd", function (value) {
      if (!_this.props.validateOption(value)) {
        _this.props.onAdd(value);

        _this.setState({
          value: '',
          errMessage: null
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onAddListDelimitedValue", function (inputValue) {
      var values = splitValues(inputValue, _this.state.listDelimiter);

      if (_this.props.onMultiAdd) {
        _this.props.onMultiAdd(values);
      } else {
        values.forEach(function (value) {
          _this.onAdd(value);
        });
      }

      _this.setState({
        showSmartButton: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onAddListDelimitedValue", function (inputValue) {
      var values = splitValues(inputValue, _this.state.listDelimiter);

      _this.onMultipleValuesInputed(values);

      _this.setState({
        showSmartButton: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onMultipleValuesInputed", function (values) {
      var uniqValues = (0, _uniqWith["default"])(_isEqual["default"], values);

      if (_this.props.onMultiAdd) {
        _this.props.onMultiAdd(uniqValues);
      } else {
        uniqValues.forEach(function (value) {
          _this.onAdd(value);
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onDelimitedListInputed", function (enabled) {
      _this.setState({
        showSmartButton: enabled
      });
    });

    _defineProperty(_assertThisInitialized(_this), "getSuggestions", function (inputValue) {
      return _this.props.selectOptions.filter(function (_ref4) {
        var value = _ref4.value;
        return value.toLowerCase().includes(inputValue.toLowerCase());
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderAutosuggest", function (suggestions, inputProps) {
      return (
        /*#__PURE__*/
        _react["default"].createElement(_reactAutosuggest["default"], {
          renderSuggestion: renderSuggestion,
          suggestions: suggestions,
          getSuggestionValue: function getSuggestionValue(suggestion) {
            return suggestion.value;
          },
          shouldRenderSuggestions: function shouldRenderSuggestions() {
            return true;
          },
          inputProps: inputProps,
          onSuggestionsFetchRequested: _this.onSuggestionsFetchRequested,
          onSuggestionsClearRequested: _this.onSuggestionsClearRequested,
          onSuggestionHighlighted: function onSuggestionHighlighted(_ref5) {
            var suggestion = _ref5.suggestion;
            return _this.setState({
              highlighted: suggestion
            });
          },
          renderInputComponent: AddForm.renderInputComponent,
          onSuggestionSelected: _this.onSuggestionSelected
        })
      );
    });

    _defineProperty(_assertThisInitialized(_this), "renderTextField", function (inputProps) {
      return (
        /*#__PURE__*/
        _react["default"].createElement(_advancedTextField["default"], inputProps)
      );
    });

    _defineProperty(_assertThisInitialized(_this), "renderSmartButton", function (errMessage) {
      var value = _this.state.value;
      return (
        /*#__PURE__*/
        _react["default"].createElement("div", {
          className: smartButtonLayout
        },
        /*#__PURE__*/
        _react["default"].createElement(_styledComponents.RoundButton, {
          type: "primary",
          onClick: function onClick() {
            return _this.onAddListDelimitedValue(value);
          },
          disabled: Boolean(errMessage)
        },
        /*#__PURE__*/
        _react["default"].createElement(_IconAddCircle["default"], {
          size: "lg",
          color: _colors.white
        })))
      );
    });

    _defineProperty(_assertThisInitialized(_this), "validateOption", function (value, values) {
      var validateOption = _this.props.validateOption;

      if (values.length > 1) {
        var bulkErrMessage = '';
        values.forEach(function (value) {
          var test = validateOption(value);

          if (test) {
            bulkErrMessage = bulkErrMessage.concat(test, ' -- ');
          }
        });

        _this.setState({
          errMessage: bulkErrMessage
        });
      } else {
        _this.setState({
          errMessage: validateOption(value)
        });
      }
    });

    _this.state = {
      value: '',
      values: [],
      suggestions: props.selectOptions,
      showSmartButton: false,
      listDelimiter: [','],
      errMessage: null
    };
    return _this;
  }

  _createClass(AddForm, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          className = _this$props.className,
          label = _this$props.label,
          autosuggest = _this$props.autosuggest,
          disabled = _this$props.disabled,
          formatMessage = _this$props.intl.formatMessage;
      var _this$state = this.state,
          value = _this$state.value,
          highlighted = _this$state.highlighted,
          suggestions = _this$state.suggestions,
          showSmartButton = _this$state.showSmartButton,
          errMessage = _this$state.errMessage;
      var bsStyle = errMessage ? 'error' : ''; // Autosuggest will pass through all these props to the input.

      var inputProps = {
        bsStyle: bsStyle,
        label: label || formatMessage(_messages["default"].add),
        onKeyDown: function onKeyDown(e) {
          return e.keyCode === RETURN && !highlighted ? _this2.onAdd(value) : null;
        },
        onChange: this.onChange,
        value: value,
        disabled: disabled,
        onMultipleValuesInputed: this.onMultipleValuesInputed,
        onDelimitedListInputed: this.onDelimitedListInputed,
        onEnterPressed: function onEnterPressed() {
          return _this2.onAdd(value);
        },
        listDelimiter: this.state.listDelimiter,
        splitValues: splitValues
      };
      return (
        /*#__PURE__*/
        _react["default"].createElement("div", null,
        /*#__PURE__*/
        _react["default"].createElement("div", {
          className: (0, _emotion.cx)(addFormLayout, className)
        },
        /*#__PURE__*/
        _react["default"].createElement("div", {
          className: attributeSelect
        }, autosuggest ? this.renderAutosuggest(suggestions, inputProps) : this.renderTextField(inputProps)), showSmartButton ? this.renderSmartButton(errMessage) : '',
        /*#__PURE__*/
        _react["default"].createElement(_styledComponents.RoundButton, {
          type: "primary",
          onClick: function onClick() {
            return _this2.onAdd(value);
          },
          disabled: !value || Boolean(errMessage)
        },
        /*#__PURE__*/
        _react["default"].createElement(_IconAdd["default"], {
          size: "lg",
          color: value ? _colors.white : _colors.teal.base
        }))), errMessage ?
        /*#__PURE__*/
        _react["default"].createElement("span", {
          className: "help-block"
        }, errMessage) : null)
      );
    }
  }]);

  return AddForm;
}(_react.Component);

_defineProperty(AddForm, "propTypes", {
  disabled: _propTypes["default"].bool,
  validateOption: _propTypes["default"].func,
  className: _propTypes["default"].string,
  onAdd: _propTypes["default"].func,
  onMultiAdd: _propTypes["default"].func,
  label: _propTypes["default"].string,
  selectOptions: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    value: _propTypes["default"].string,
    label: _propTypes["default"].string
  })),
  autosuggest: _propTypes["default"].bool,
  intl: _propTypes["default"].shape(_propTypes2.intlShape).isRequired
});

_defineProperty(AddForm, "defaultProps", {
  validateOption: function validateOption() {
    return null;
  },
  className: '',
  onAdd: function onAdd() {},
  onMultiAdd: undefined,
  label: '',
  selectOptions: [],
  autosuggest: false,
  disabled: false
});

_defineProperty(AddForm, "renderInputComponent", function (inputProps) {
  return (
    /*#__PURE__*/
    _react["default"].createElement(_TextField["default"], inputProps)
  );
});

var _default = (0, _reactIntl.injectIntl)(AddForm);

exports["default"] = _default;